<template>
  <b-row>
    <b-modal
      id="modal-register"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      centered
      size="lg"
      title="Add User"
      hide-footer
    >
      <AddUser :token="token" @reload="data" />
    </b-modal>

    <b-col cols="12">
      <div class="d-flex justify-content-end">
        <b-button variant="success" v-b-modal.modal-register>
          <i class="feather icon-user"></i>
          Add User
        </b-button>
      </div>
    </b-col>
    <b-col cols="12" md="1" sm="1" class="my-1">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          :options="pageOptions"
         
        />
      </b-form-group>
    </b-col>

    <b-col md="10" class="my-1">
      <b-form-group
        label="Filter"
        label-cols-sm="8"
        label-align-sm="right"
        label-size="sm"
        label-for="filterInput"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="Type to Search"
          />
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>

    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        :per-page="perPage"
        :current-page="currentPage"
        :items="users"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template v-slot:cell(Action)="data">
          <b-button
            variant="primary"
            size="sm"
            class="mr-1"
            @click="getIdOfUser(data.item)"
          >
            <i class="feather icon-edit"></i>
          </b-button>
        </template>
      </b-table>

      <div class="d-flex justify-content-center mb-1">
        <b-spinner
          variant="success"
          label="Spinning"
          block
          v-if="loading"
          style="width: 3rem; height: 3rem"
        ></b-spinner>
      </div>
    </b-col>

    <b-col cols="12">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        size="sm"
        class="my-0"
      />
      <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import AddUser from "./AddUser.vue";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BFormCheckbox,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    AddUser,
  },
  data() {
    return {
      showSpinner: true,
      perPage: 5,

      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 0,
      sortBy: "lastName",
      sortDesc: false,
      sortDirection: "asc",
      token: localStorage.getItem("accessToken"),
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        // { key: "userName", label: "User Name", sortable: true },
        { key: "firstName", label: "First Name", sortable: true },
        { key: "lastName", label: "Last Name", sortable: true },
        { key: "email", label: "Email", sortable: true },
        // { key: "isActive", label: "IsActive", sortable: true },
        { key: "phoneNumber", label: "Phone Number", sortable: true },
        { key: "Action", label: "Action", sortable: false, isSortable: false },
      ],
      items: [],
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("userModule", {
      users: "users",
      loading: "loading",
    }),
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.getUsers();
  },
  async mounted() {
    await this.getUserListAction()
      .then(() => {
        this.totalRows = this.users.length;
      })
      .catch((response) => {
        console.log(response);
      });
  },
  methods: {
    ...mapActions("userModule", ["getUserListAction"]),
    data(data) {
      if (data) {
        this.getUserListAction();
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getIdOfUser(item) {
      this.$router.push({ name: "role-view-user", params: { id: item.id } });
    },
  },
};
</script>

